import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './SelectBanner.module.scss';
import { Props } from './SelectBanner.types';

// t('selectBanner.count_one', 'élément sélectionné')
// t('selectBanner.count_other', 'éléments sélectionnés')
// t('selectBanner.countWithCount_one', '{{count}} élément sélectionné')
// t('selectBanner.countWithCount_other', '{{count}} éléments sélectionnés')

const SelectBanner = ({ onExportButtonClick, count, exportLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.itemCount}>{t('selectBanner.countWithCount', { count })}</div>
      <Button onClick={onExportButtonClick} loading={exportLoading}>
        {t('selectBanner.exportSelection', 'Exporter la sélection')}
      </Button>
    </div>
  );
};

export default SelectBanner;
